import { useState } from 'react';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/daihpc3oh653ivfvodjg';

interface FormResponse {
  code?: string;
  message?: string;
  meta?: { message?: string; detail?: string };
}

type Status = 'idle' | 'loading' | 'success' | 'error';

export default function NewsletterForm() {
  const [status, setStatus] = useState<Status>('idle');
  const [feedback, setFeedback] = useState('');

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);

    const honey = String(data.get('website_alt') || '').trim();
    if (honey) {
      setStatus('success');
      setFeedback('订阅成功，档案更新会第一时间发到你的邮箱。');
      form.reset();
      return;
    }

    const params = new URLSearchParams();
    data.forEach((value, key) => {
      if (key === 'website_alt') return;
      if (typeof value === 'string' && value.trim() !== '') {
        params.append(key, value);
      }
    });

    setStatus('loading');
    setFeedback('');

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const responseText = await response.text();
      let parsed: FormResponse | null = null;
      try {
        parsed = JSON.parse(responseText) as FormResponse;
      } catch {
        parsed = null;
      }

      const code = parsed?.code;
      const serverMsg =
        parsed?.meta?.message ||
        parsed?.message ||
        parsed?.meta?.detail ||
        responseText;

      if (
        response.ok &&
        code === 'OK' &&
        !String(serverMsg).toLowerCase().includes('spam')
      ) {
        setStatus('success');
        setFeedback('订阅成功，档案更新会第一时间发到你的邮箱。');
        form.reset();
      } else {
        setStatus('error');
        setFeedback(
          `提交未成功：${serverMsg || '请稍后再试一次'}。你可以检查邮箱格式后重试。`,
        );
      }
    } catch {
      setStatus('error');
      setFeedback('网络似乎不太稳定，请稍后再试一次。');
    }
  };

  return (
    <form
      id="hlkb-newsletter-form"
      data-readdy-form
      onSubmit={handleSubmit}
      className="w-full"
      noValidate
    >
      <input
        className="alt-contact-field"
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />
      <div className="flex flex-col sm:flex-row gap-3">
        <label htmlFor="hlkb-newsletter-email" className="sr-only">
          订阅邮箱
        </label>
        <input
          id="hlkb-newsletter-email"
          type="email"
          name="email"
          required
          placeholder="留下邮箱，接收新档案提醒"
          className="flex-1 px-4 py-3 rounded-md bg-background-50/10 border border-background-300/60 text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500/60 transition-colors"
        />
        <button
          type="submit"
          disabled={status === 'loading'}
          className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {status === 'loading' ? '提交中…' : '订阅线索'}
        </button>
      </div>
      {feedback && (
        <p
          role="status"
          className={`mt-3 text-xs leading-relaxed ${
            status === 'success' ? 'text-primary-400' : 'text-accent-400'
          }`}
        >
          {feedback}
        </p>
      )}
      <p className="mt-3 text-xs text-foreground-600 leading-relaxed">
        我们只用来发送档案更新与修订通知，不做任何其他用途。
      </p>
    </form>
  );
}